import { IIconProps } from "./types"

export default function IconVec3(props: IIconProps) {
  const width = props.size || props.width || 30
  const height = props.size || props.height || 26
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 30 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.967 9.73889L4.82812 4.36644L21.3078 2L24.8906 9.5799L5.967 9.73889Z"
        fill="#CCCCCC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.47764 12.5018L19.238 16.9795L16.6239 22.8732L0 15.7223L1.38655 8.58984L4.21518 9.16667L4.47764 12.5018Z"
        fill="#3A3939"
      />
      <path
        d="M23.8281 22.2781C26.3403 19.9275 27.3746 16.5074 26.5489 13.3047"
        stroke="#3A3939"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.0617 21.9025L26.5777 23.4333L20.8281 24.7348L22.2035 19L23.7195 20.5455L25.0617 21.9025Z"
        fill="#3A3939"
      />
    </svg>
  )
}
